import { applyMiddleware, createStore } from 'redux';
import { createWrapper } from 'next-redux-wrapper';
import reducer from './reducer';

// create a makeStore function
const makeStore = ({ isServer }) => {
  const middlewares = [];
  if (process.env.NODE_ENV === 'development') {
    const { logger } = require('redux-logger');
    middlewares.push(logger);
  }

  // If it's on server side, create a store
  if (isServer) return createStore(reducer, applyMiddleware(...middlewares));

  // If it's on client side, create a store which will persist
  const { persistStore, persistReducer } = require('redux-persist');
  const storage = require('redux-persist/lib/storage').default;

  const persistConfig = {
    key: 'Decooj',
    storage, // if needed, use a safer storage
  };

  const persistedReducer = persistReducer(persistConfig, reducer); // Create a new reducer with our existing reducer

  const store = createStore(persistedReducer, applyMiddleware(...middlewares)); // Creating the store again

  store.__persistor = persistStore(store); // This creates a persistor object & push that persisted object to .__persistor, so that we can avail the persistability feature

  return store;
};

// export an assembled wrapper
export const wrapper = createWrapper(makeStore);
